var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('input',{staticClass:"checkbox-item",attrs:{"type":_vm.type,"name":_vm.name,"id":`${_vm.name}-${_vm.id}`},domProps:{"checked":_vm.isChecked},on:{"change":function($event){return _vm.$emit('select', { event: $event, data: _vm.data })}}}),_c('label',{attrs:{"for":`${_vm.name}-${_vm.id}`}},[_vm._t("label")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }